import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, testid }) {
    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[60] flex items-center justify-center p-4"
                >
                    <div
                        onClick={onClose}
                        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
                    />
                    <motion.div
                        initial={{ opacity: 0, scale: 0.92, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: 20 }}
                        transition={{ type: "spring", damping: 22, stiffness: 240 }}
                        className="relative w-full max-w-md surface-2 p-5 max-h-[90vh] overflow-y-auto"
                        data-testid={testid}
                    >
                        <div className="flex items-center justify-between mb-3">
                            {title && (
                                <h3 className="font-display font-black text-2xl uppercase tracking-tight">
                                    {title}
                                </h3>
                            )}
                            <button
                                onClick={onClose}
                                className="ml-auto w-8 h-8 surface-3 flex items-center justify-center hover:border-neon-orange shrink-0"
                                data-testid="modal-close"
                            >
                                <X size={16} />
                            </button>
                        </div>
                        {children}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
